import { RouterProvider, createBrowserRouter } from "react-router-dom"
import Login from "@/pages/Login"
import PasskeySetup from "@/pages/PasskeySetup"
import PasskeyVerify from "@/pages/PasskeyVerify"
import { Toaster } from "@/components/ui/toaster"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/passkey/setup",
    element: <PasskeySetup />,
  },
  {
    path: "/passkey/verify",
    element: <PasskeyVerify />,
  },
], {
  basename: '/client'
})

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  )
}

export default App